import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BaseTaoSpreadsheetGuide from "../pages/basetao-spreadsheet-guide/page";
import BaseTaoTutorial from "../pages/basetao-spreadsheet-tutorial/page";
import BaseTaoReview from "../pages/basetao-spreadsheet-review/page";
import BaseTaoTemplate from "../pages/basetao-spreadsheet-template/page";
import BaseTaoFormulas from "../pages/basetao-spreadsheet-formulas/page";
import BaseTaoAutomation from "../pages/basetao-spreadsheet-automation/page";
import BaseTaoShippingCost from "../pages/basetao-shipping-cost/page";
import BaseTaoCoupon from "../pages/basetao-coupon/page";
import BaseTaoWarehouse from "../pages/basetao-warehouse/page";
import IsBaseTaoLegit from "../pages/is-basetao-legit/page";
import BaseTaoBeginner from "../pages/basetao-spreadsheet-beginner/page";
import ShoppingGuide from "../pages/basetao-shopping-guide/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/basetao-spreadsheet-guide", element: <BaseTaoSpreadsheetGuide /> },
  { path: "/basetao-spreadsheet-tutorial", element: <BaseTaoTutorial /> },
  { path: "/basetao-spreadsheet-review", element: <BaseTaoReview /> },
  { path: "/basetao-spreadsheet-template", element: <BaseTaoTemplate /> },
  { path: "/basetao-spreadsheet-formulas", element: <BaseTaoFormulas /> },
  { path: "/basetao-spreadsheet-automation", element: <BaseTaoAutomation /> },
  { path: "/basetao-shipping-cost", element: <BaseTaoShippingCost /> },
  { path: "/basetao-coupon", element: <BaseTaoCoupon /> },
  { path: "/basetao-warehouse", element: <BaseTaoWarehouse /> },
  { path: "/is-basetao-legit", element: <IsBaseTaoLegit /> },
  { path: "/basetao-spreadsheet-beginner", element: <BaseTaoBeginner /> },
  { path: "/basetao-shopping-guide", element: <ShoppingGuide /> },
  { path: "*", element: <NotFound /> },
];

export default routes;